var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.mapSVG)?_c('svg',{staticClass:"svg-map mx-auto mb-3",attrs:{"viewBox":_vm.mapSVG.viewBox,"xmlns":"http://www.w3.org/2000/svg"}},_vm._l((_vm.mapSVG.paths),function(path){return _c('map-path',{key:path.id,attrs:{"path":path}})}),1):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }